ChosenPeriods = new (function () {
  this.setSelects = () => {
    $(".chosen-calendar-year-form #calendar_year").select2({
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });
  };
})();
